import {
  ApiResponseError,
  getBackendClient,
  unwrapApiResponse,
  type ApiSchema,
  type BackendClientOptions,
} from './client'

export type AgentWire = ApiSchema<'GetAgent'>
export type TtsPreviewRequest = ApiSchema<'PostTtsPreview'>

export type ListAgentsQuery = {
  customer_id?: string
}

export async function listAgents(
  query: ListAgentsQuery = {},
  options: BackendClientOptions = {},
): Promise<AgentWire[]> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/agents', {
    params: { query },
  }))
}

async function blobErrorDetail(blob: Blob | undefined): Promise<unknown> {
  if (!blob) {
    return null
  }
  const text = await blob.text()
  if (!text) {
    return null
  }
  try {
    const parsed = JSON.parse(text) as { detail?: unknown }
    return parsed.detail ?? parsed
  }
  catch {
    return text
  }
}

export async function previewAgentTts(
  agentId: string,
  body: TtsPreviewRequest,
): Promise<Blob> {
  const client = getBackendClient()
  const result = await client.POST('/agents/{agent_id}/tts_preview', {
    params: { path: { agent_id: agentId } },
    body,
    parseAs: 'blob',
  })

  if (result.error || !result.data) {
    throw new ApiResponseError(
      result.response,
      { detail: await blobErrorDetail(result.error instanceof Blob ? result.error : undefined) },
    )
  }

  return result.data
}
